import "assets/styles/reports/balanceSheet.scss";
import React, {useEffect, useRef, useState} from "react";
import {apiGetFactor} from "api/factorApi";
import {styled} from "@mui/material";
import {useAppDispatch, useAppSelector} from "store/store";
import BasicButton from "../BasicInputs/BasicButton";
import ReactToPrint from "react-to-print";
import useOfficialFactor from "../Factor2/print/useOfficialFactor";

const ItemContainer = styled("div")(({theme}) => ({
    borderRadius: theme.shape.borderRadius,
    marginBottom: "36px",
}));

export default function OfficialPrint({
                                          factorId,
                                          factorType,
                                          autoPrint,
                                      }: {
    factorId: string | number;
    factorType: string;
    autoPrint?: boolean;
}) {
    const dispatch = useAppDispatch();
    const store = useAppSelector((state: any) => state);
    const business = store.businessReducer?.business;
    const {token} = business;

    const [factorIsFetched, setFactorIsFetched] = useState(false);

    const callBack = () => {
        return setFactorIsFetched(true);
    };

    const printRef = useRef<any>(null);
    const {contentRef, content} = useOfficialFactor();

    useEffect(() => {
        dispatch(apiGetFactor(factorId, factorType, token, callBack));
    }, [token]);

    useEffect(() => {
        if (factorIsFetched && autoPrint) printRef.current.handleClick();
    }, [factorIsFetched]);

    return (
        <ItemContainer style={{height: "fit-content", backgroundColor: "white"}}>
            <div className="hidden">{content}</div>
            <ReactToPrint
                ref={printRef}
                trigger={() => (
                    <BasicButton fullWidth variant="outlined">
                        <span>فیش فاکتور رسمی</span>
                    </BasicButton>
                )}
                content={() => contentRef.current}
            />
        </ItemContainer>
    );
}
